import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Application, ItemListResponse } from '@models';
import { ApplicationService, NotificationService } from '@services';
import { ResolveUserPipe } from '@pipes';
import { httpResource } from '@angular/common/http';
import { environment } from '@environment';
import { ListComponent } from '@components/list/list.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-application-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  imports: [
    DatePipe,
    ResolveUserPipe,
    AsyncPipe,
    RouterModule,

    MatListModule,
    MatIconModule,
    MatButtonModule,

    ListComponent,
  ],
})
export class ApplicationListComponent {
  service = inject(ApplicationService);
  notificationService = inject(NotificationService);

  applications = httpResource(() => `${environment.komainuHost}/application/?take=50`, {
    parse: (response: unknown) => {
      const roles = response as Application[];
      return {
        items: roles || [],
        count: roles?.length || 0,
      } as ItemListResponse<Application>;
    }
  });

  token = signal<string | null>(null);
}
